module.exports = __webpack_public_path__ + "img/icon-loader-voiter3.0a87e81d.svg";